import { Box, BoxProps, ButtonNew, Icon, ModBox, Spacer, SpacerNew, Text, TextProps } from '@jfs/ui-new'
import { StackActions, useNavigation, useRoute } from '@react-navigation/native'
import React, { useCallback, useEffect, useState } from 'react'
import { AepsButton } from '../../comps/AepsButton'
import { AmountText } from '../../comps/AmountText'
import { BrandLogo, Container } from '../../comps/Container'
import { PoweredByBanner } from '../../comps/PoweredByBanner'
import { ProgressDialog } from '../../comps/ProgressDialog'
import { RowItem } from '../../comps/RowItem'
import { ScanUserModal } from '../../comps/ScanUserModal'
import { SubTitle } from '../../comps/SubTitle'
import { Title } from '../../comps/Title'
import { TransactionStatus } from '../../comps/TransactionStatus'
import { RootStore, useLazyApiData, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { downloadWeb, sendDataForDownload } from '../../network/downloadReceipt'
import { nativeJSComm, nativeJSMapper } from '../../util/WebFns'
import {
  formatRawDateStr,
  getFingerPrintData,
  getFormattedAmount,
  getMaskedAadhaarNumber,
  getMaskedMobileNumber,
  getMaskedVIDNumber,
  parseBioMetricDeviceInfo,
} from '../../util/utill'
import { StatusText } from '../TransactionEnquiryScreen/StatusText'
import { MoreAEPSServices } from './MoreAEPSServices'

const MAX_NO_RETRY = 3

export const CashWithdrawalStatusScreen = () => {
  const {
    cashWithdrawal,
    printReceipt,
    setMessage,
    cashWithdrawalOrDepositApi,
    getBankId,
    fundTransferApi,
    getBalanceApi,
    getMiniStatementApi,
    setBioMetricDeviceInfo,
    sendEventAsync,
  } = useStores((root) => ({
    cashWithdrawal: root.customer.cashWithdrawal,
    printReceipt: root.agent.printReceipt,
    setMessage: root.message.setMessage,
    cashWithdrawalOrDepositApi: root.customer.cashWithdrawalOrDepositApi,
    getBankId: root.banks.getBankId,
    fundTransferApi: root.customer.fundTransferApi,
    getBalanceApi: root.customer.getBalanceApi,
    getMiniStatementApi: root.customer.getMiniStatementApi,
    setBioMetricDeviceInfo: root.agent.setBioMetricDeviceInfo,
    sendEventAsync: root.agent.session.sendEventAsync,
  }))

  const [printReceiptApi, printReceiptHandler] = useLazyApiData(printReceipt)
  const [lazycashWithdrawalApi, cashWithdrawalApiHandler] = useLazyApiData(cashWithdrawalOrDepositApi)
  const [lazyfundTransferApi, fundTransferApiHandler] = useLazyApiData(fundTransferApi)
  const [lazyGetBalance, getBalanceHandler] = useLazyApiData(getBalanceApi)
  const [lazyGetStatement, getStatementHandler] = useLazyApiData(getMiniStatementApi)
  const [showUserAuthModel, setShowUserAuthModel] = useState(false)
  const [shouldShowFingerPrintModel, setShouldShowFingerPrintModel] = React.useState(false)
  const [fingerPrintError, setFingerPrintError] = React.useState({ code: '', error: '', title: '' })
  const authModeRef = React.useRef(null)
  const isLoading = [
    cashWithdrawalApiHandler?.state,
    fundTransferApiHandler?.state,
    getBalanceHandler?.state,
    getStatementHandler?.state,
  ].includes('pending')

  const navigation = useNavigation()
  const route: any = useRoute()

  useEffect(() => {
    if (getStatementHandler?.state === 'fulfilled') {
      navigation.dispatch(StackActions.replace(Screens.STATEMENT_LIST))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getStatementHandler?.state])

  // const [noOfRetry, setNoOfRetry] = useState(1)
  const [noOfRetry, setNoOfRetry] = useState(route.params?.noOfRetry ?? 1)


  const staticData = CONFIGURATION[route.params.type]

  const amount = Number(route.params?.amount || 0);
  const currentBankThreshold = route.params?.currentBankThreshold || 0; // Passed down through route params context
  const isHighValueTransaction = currentBankThreshold > 0 && amount >= currentBankThreshold;

  useEffect(() => {
    navigation.setOptions({
      headerTitle: staticData.headerTitle,
      headerStyle: {
        backgroundColor:
          route.params.type === 'fetch_perticular_transaction'
            ? '#DF9F39'
            : cashWithdrawal?.status === 'SUCCESS'
              ? '#DF9F39'
              : '#C94949',
      },
    })
  }, [cashWithdrawal, cashWithdrawal?.status, navigation, route.params.type, staticData.headerTitle])

  useEffect(() => {
    if (printReceiptHandler.state === 'fulfilled') {
      console.log('api handler ', printReceiptHandler?.data)
      if (printReceiptHandler?.data?.response) {
        handleDownloadResponse(printReceiptHandler.data)
      }
    } else if (printReceiptHandler.state === 'rejected') {
      const message = printReceiptHandler?.data?.message
      setMessage(message ?? 'Failed to download receipt')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [printReceiptHandler.state])

  const handleDownloadResponse = (response?: any) => {
    if (window.AepsWebViewInterface) {
      sendDataForDownload(response, onDownloadSuccess, onDownloadFailed)
    } else {
      downloadWeb(response, onDownloadSuccess)
    }
  }

  const onDownloadSuccess = (success: any) => {
    setMessage(success, 'POSITIVE')
  }
  const onDownloadFailed = (error: any) => {
    setMessage(error, 'NEGATIVE')

    console.log('onDownloadFailed error', error)
  }

  useEffect(() => {
    nativeJSComm(nativeJSMapper.enableScreenShot)
    return () => nativeJSComm(nativeJSMapper.disableScreenshot)
  }, [])

  const displayPerticularTransactionList = () => {
    return (
      <>
        {cashWithdrawal?.transactionId && <RowItem heading="Transaction ID" detail={cashWithdrawal?.transactionId} />}
        {cashWithdrawal?.rrnNo && cashWithdrawal?.rrnNo !== 'null' && (
          <RowItem heading="RRN No." detail={cashWithdrawal?.rrnNo} />
        )}
        {cashWithdrawal?.tnxTime && (
          <RowItem heading="Transaction Time" detail={formatRawDateStr(cashWithdrawal?.tnxTime)} />
        )}
        {cashWithdrawal?.transferType && <RowItem heading="Transaction Type" detail={cashWithdrawal?.transferType} />}
        {cashWithdrawal?.customerName && <RowItem heading="Customer Name" detail={cashWithdrawal?.customerName} />}
      </>
    )
  }

  const fundTransferExtraFields = () => {
    return (
      <>
        {cashWithdrawal?.remittersAadhar && (
          <RowItem heading={'Payer’s Aadhar'} detail={getMaskedAadhaarNumber(cashWithdrawal?.remittersAadhar ?? '')} />
        )}
        {cashWithdrawal?.remittersVID && (
          <RowItem heading={'Payer’s VID'} detail={getMaskedVIDNumber(cashWithdrawal?.remittersVID)} />
        )}
        {cashWithdrawal?.mobileNo && (
          <RowItem heading={'Payer’s Mobile'} detail={getMaskedMobileNumber(cashWithdrawal.mobileNo)} />
        )}
        <RowItem heading="Payee Aadhar" detail={getMaskedAadhaarNumber(cashWithdrawal?.beneficiaryAadhar ?? '')} />
      </>
    )
  }

  const download = () => {
    let rrnNo = cashWithdrawal?.rrnNo
    if (rrnNo?.length > 0) {
      printReceiptApi(rrnNo)
    } else {
      setMessage('Failed to download receipt.', 'NEGATIVE')
    }
  }

  const onRetryButtonPress = (fingerprintData) => {
    setNoOfRetry(noOfRetry + 1)
    if (['CUSTOMER_CW', 'CUSTOMER_CD'].includes(route?.params?.activityType)) {
      lazycashWithdrawalApi(
        route.params.aadhaarNo,
        fingerprintData,
        getBankId(route.params.bankName, route?.params?.activityType),
        route.params.bankName,
        route.params.mobileNo,
        route.params.amount,
        route.params.vid,
        route.params.consentDetails,
        route.params.type,
        route.params?.authorizationCode,
        authModeRef?.current,
      )
    } else if (route?.params?.activityType === 'CUSTOMER_FT') {
      lazyfundTransferApi({
        aadhaarNumber: route.params.aadhaarNo,
        vid: route.params.vid,
        bankId: getBankId(route.params.bankName, 'CUSTOMER_FT'),
        bankName: route.params.bankName,
        mobileNo: route.params.mobileNo,
        amount: route.params.amount,
        beneficieryBankName: route.params.beneficieryBankName,
        beneficieryBankId: getBankId(route.params.beneficieryBankName, 'CUSTOMER_FT'),
        beneficieryAadhaar: route.params.beneficieryAadhaar,
        beneficieryVid: route.params.beneficieryVid,
        fingerprintData,
        consentDetails: route.params.consentDetails,
        authMode: authModeRef?.current,
      })
    } else if (route?.params?.activityType === 'CUSTOMER_BI') {
      lazyGetBalance(
        route.params.aadhaarNo,
        route.params.bankId,
        route.params.bankName,
        route.params.mobileNo,
        fingerprintData,
        route.params.vid,
        route.params.consentDetails,
        authModeRef?.current,
      )
    } else if (route?.params?.activityType === 'CUSTOMER_MS') {
      lazyGetStatement(
        route.params.aadhaarNo,
        route.params.bankId,
        route.params.bankName,
        route.params.mobileNo,
        fingerprintData,
        route.params.vid,
        route.params.consentDetails,
        authModeRef?.current,
      )
    }
  }

  const shouldShowRetryButton = useCallback(
    () => (route.params?.showRetry ?? false) && cashWithdrawal?.status !== 'SUCCESS',
    [cashWithdrawal?.status, route.params?.showRetry],
  )

  const onScanSuccess = (sucess: any) => {
    getFingerPrintData(sucess, route.params.consentDetails?.text1, authModeRef.current).then((fingerprintData: any) => {
      setShouldShowFingerPrintModel(false)
      setBioMetricDeviceInfo(parseBioMetricDeviceInfo(fingerprintData))
      sendEventAsync({
        status: 'FINGERPRINT_CAPTURED',
        biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
      })
      onRetryButtonPress(fingerprintData)
    })
  }

  const onScanError = (error: any) => {
    sendEventAsync({
      status: 'FINGERPRINT_ERROR',
      errorDescription: error,
    })
    setFingerPrintError(JSON.parse(error))
  }

  const scanUser = (authMode: 'FACE' | 'FINGER_PRINT') => {
    setShowUserAuthModel(false)
    setFingerPrintError({ code: '', error: '', title: '' })
    authModeRef.current = authMode
    if (isHighValueTransaction && ['CUSTOMER_CW', 'CUSTOMER_CD'].includes(route?.params?.activityType)) {
      console.log("==> High value transaction retry detected. Redirecting to get a fresh OTP.");

      navigation.dispatch(
        StackActions.replace(Screens.REVIEW_CASH_WITHDRAWAL as never, {
          ...route.params,
          isOtpSent: false,
          isOtpVerified: false,
          noOfRetry: noOfRetry + 1
        } as never)
      );
      return;
    }
    if (window?.AepsWebViewInterface) {
      setShouldShowFingerPrintModel(true)
      nativeJSComm(nativeJSMapper.scanFingerPrint, onScanSuccess, onScanError, { authMode })
    } else {
      onRetryButtonPress('')
    }
  }

  return (
    <Box height="100%">
      <Box height="100%" flex={1} backgroundColor={'WHITE'} overflow={'scroll'}>
        {route.params.type !== 'fetch_perticular_transaction' && (
          <TransactionStatus
            message={staticData.message}
            rrnNo={cashWithdrawal?.rrnNo}
            status={cashWithdrawal?.status}
          />
        )}
        <Container
          backgroundColor={
            route.params.type === 'fetch_perticular_transaction'
              ? 'PRIMARY'
              : cashWithdrawal?.status === 'SUCCESS'
                ? 'PRIMARY'
                : 'ERROR'
          }
          paddingBottom={0}
          paddingHorizontal={0}>
          <Box alignItems={'center'} ph={16} flexGrow={1} backgroundColor="WHITE">
            {(cashWithdrawal?.status === 'SUCCESS' || route.params.type === 'fetch_perticular_transaction') && (
              <>
                <SubTitle subTitle={staticData.amountTitle} />
                <Spacer size={8} />

                <AmountText amount={cashWithdrawal?.amount ?? '0'} />
              </>
            )}
            {cashWithdrawal?.status === 'SUCCESS' && route.params.type === 'cash_withdrawal' && (
              <RowItem
                isFullWidth={false}
                heading={'Bank Account Balance'}
                detail={
                  cashWithdrawal?.availableBalance
                    ? getFormattedAmount(+cashWithdrawal?.availableBalance)
                    : 'Unable to fetch balance'
                }
              />
            )}

            {cashWithdrawal?.status !== 'SUCCESS' && route.params.type !== 'fetch_perticular_transaction' && (
              <Title title={cashWithdrawal?.message ?? ''} />
            )}
            {cashWithdrawal?.status === 'SUCCESS' && <MoreAEPSServices {...route.params} />}
            <Spacer size={24} />
            <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
            {route.params.type === 'fetch_perticular_transaction' && (
              <Box
                borderStyle={'dashed'}
                borderBottomWidth={1}
                borderColor={'PRIMARY_GREY'}
                width={'100%'}
                flexDirection={'column'}
                justifyContent={'center'}
                alignItems={'center'}
                pv={16}>
                <Box flexDirection={'row'} alignItems={'center'}>
                  <Icon
                    id={ICON_INFO[cashWithdrawal?.status]?.id}
                    color={ICON_INFO[cashWithdrawal?.status]?.color}
                    size={24}
                  />
                  <Spacer direction="horizontal" size={16} />
                  <Text {...styles.sucessfullText}>
                    Transaction {STATUS_DESC[cashWithdrawal?.status] ?? cashWithdrawal?.status}
                  </Text>
                </Box>
                {cashWithdrawal?.status !== 'SUCCESS' && (
                  <>
                    <Spacer direction="vertical" size={16} />
                    <StatusText text={cashWithdrawal?.message} />
                  </>
                )}
              </Box>
            )}

            <Spacer size={18} />
            {route.params.type === 'fetch_perticular_transaction' && displayPerticularTransactionList()}
            {route.params.type === 'fund_transfer' && fundTransferExtraFields()}
            {cashWithdrawal?.aadhaarNumber && (
              <RowItem heading="Aadhaar Number" detail={getMaskedAadhaarNumber(cashWithdrawal?.aadhaarNumber || '')} />
            )}
            {route.params.type !== 'fund_transfer' && route?.params?.vid && (
              <RowItem heading="Aadhaar Virtual Id" detail={getMaskedVIDNumber(route?.params?.vid || '')} />
            )}
            {cashWithdrawal?.bankName && <RowItem heading="Bank's Name" detail={cashWithdrawal?.bankName} />}
            {cashWithdrawal?.mobileNo && route.params.type !== 'fund_transfer' && (
              <RowItem
                heading={'Mobile'}
                detail={
                  route.params.type === 'fetch_perticular_transaction'
                    ? cashWithdrawal.mobileNo
                    : getMaskedMobileNumber(cashWithdrawal.mobileNo)
                }
              />
            )}
            {cashWithdrawal?.status === 'SUCCESS' && staticData.rowItemAmountHeading && (
              <RowItem
                heading={staticData.rowItemAmountHeading}
                detail={getFormattedAmount(+(cashWithdrawal?.amount ?? '0'))}
              />
            )}
          </Box>
        </Container>
      </Box>
      <ModBox
        show={
          (cashWithdrawal?.status === 'SUCCESS' && cashWithdrawal?.rrnNo?.length > 0) ||
          (cashWithdrawal?.status === 'SUCCESS' && route.params.type === 'fetch_perticular_transaction')
        }
        alignItems={'center'}
        backgroundColor={'WHITE'}
        justifyContent="center">
        <ButtonNew
          type={'secondarySmall'}
          title={' Print Receipt'}
          onPress={download}
          color={'WHITE'}
          underlayColor={'BRAND_PRIMARY_WHITE'}
          borderColor={'PRIMARY'}
          titleColor={'PRIMARY'}
        />
      </ModBox>
      <Box padding={16} backgroundColor="WHITE" flexDirection={'row'}>
        <Box flex={1}>
          <AepsButton title={'Okay'} onPress={() => navigation.goBack()} disabled={false} />
        </Box>
        <SpacerNew direction="horizontal" size={shouldShowRetryButton() ? 8 : 0} />
        <ModBox flex={1} show={shouldShowRetryButton()}>
          <ButtonNew
            type={'secondaryFullWidth'}
            borderColor={'ERROR'}
            titleColor={'ERROR'}
            height={48}
            title={noOfRetry > MAX_NO_RETRY ? 'Retry' : `Retry ${noOfRetry} of ${MAX_NO_RETRY}`}
            onPress={() => setShowUserAuthModel(true)}
            disabled={noOfRetry > MAX_NO_RETRY}
            isLoading={isLoading}
          />
        </ModBox>
      </Box>
      <BrandLogo />
      <PoweredByBanner />
      <ScanUserModal show={showUserAuthModel} onDismiss={() => setShowUserAuthModel(false)} onPress={scanUser} />
      <ProgressDialog
        error={fingerPrintError}
        onRetry={() => scanUser(authModeRef?.current)}
        show={shouldShowFingerPrintModel || isLoading}
        type={
          fingerPrintError.code
            ? 'error'
            : isLoading
              ? 'loader'
              : authModeRef.current === 'FACE'
                ? 'face'
                : 'fingerprint'
        }
        onCancel={() => {
          setShouldShowFingerPrintModel(false)
          setFingerPrintError({ code: '', error: '', title: '' })
        }}
      />
    </Box>
  )
}

const STATUS_DESC = {
  SUCCESS: 'Successful',
  FAILED: 'Failed',
  INITIATED: 'Initiated',
}

const ICON_INFO = {
  SUCCESS: {
    id: 'ROUND_TICK_FILLED',
    color: 'BRAND_PRIMARY_GREEN',
  },
  FAILED: {
    id: 'CLEAR',
    color: 'ERROR',
  },
  INITIATED: {
    id: 'INFO',
    color: 'BRAND_PRIMARY_ORANGE',
  },
}

const styles = {
  container: {
    height: '100%',
  } as BoxProps,
  amountText: {
    fontSize: 46,
    color: 'BLACK_21',
  } as TextProps,
  sucessfullText: {
    fontSize: 12,
    color: 'BLACK_21',
    fontFamily: 'jioType-bold',
  } as TextProps,
  errorText: {
    fontSize: 12,
    color: 'TEXT_ERROR',
    fontFamily: 'jioType-medium',
  } as TextProps,
}
const CONFIGURATION: any = {
  cash_withdrawal: {
    headerTitle: 'Cash Withdrawal',
    message: 'Congratulations! \n Your request has been processed.',
    amountTitle: 'Amount to pay by cash to customer',
    rowItemAmountHeading: 'Withdrawal amount',
  },
  cash_deposit: {
    headerTitle: 'Cash Deposit',
    message: 'Congratulations! \n Your request has been processed.',
    amountTitle: 'Amount to collect by cash from customer',
    rowItemAmountHeading: 'Amount Deposited',
  },
  balance_enquiry: {
    headerTitle: 'Balance Enquiry',
    message: 'Congratulations! \n Your request has been processed.',
    amountTitle: 'Customer’s Account Balance',
  },
  fetch_perticular_transaction: {
    headerTitle: 'Transaction Enquiry',
    amountTitle: 'Transaction Amount',
  },
  mini_statement: {
    headerTitle: 'Mini Statement',
  },
  fund_transfer: {
    headerTitle: 'Fund Transfer',
    message: 'Congratulations! \n Your request has been processed.',
    amountTitle: 'Amount debited from customer’s bank account',
    rowItemAmountHeading: 'Amount Transferred',
  },
}
